import { useLanguage } from '@/contexts/LanguageContext';
import translations from '@/translations';

export const useTranslation = () => {
  const { language, changeLanguage } = useLanguage();
  
  const t = (key, params = {}) => {
    if (!key) return '';
    
    const keys = key.split('.');
    let translation = translations[language];
    
    // Nếu không có bản dịch cho ngôn ngữ hiện tại, sử dụng tiếng Việt làm fallback
    if (!translation) {
      translation = translations['vi'];
    }
    
    try {
      for (const k of keys) {
        if (!translation[k]) return key; // Trả về key nếu không tìm thấy bản dịch
        translation = translation[k];
      }
      
      // Handle parameter interpolation
      if (params && typeof translation === 'string') {
        return translation.replace(/\{\{(\w+)\}\}/g, (match, paramName) => {
          return params[paramName] !== undefined ? params[paramName] : match;
        });
      }
      
      return translation;
    } catch (error) {
      console.error(`Translation error for key: ${key}`, error);
      return key;
    }
  };
  
  return { t, language, changeLanguage };
}; 